<template>

        <section>
          <div class="hr"></div>
            <div class="container">
                <div class="content">
                    <h1>No love, no pay.</h1>
                    <p>We're not in the business of making money from unhappy users.</p>
                    <p>If you're unhappy with Skippr at any point, we'll refund your most-recent payment.</p>

                    <!--<div class="progress-wrapper" style="display: none;">-->
                        <!--<p class="progress-label">Launch an instant 30 day demo</p>-->
                    <!--</div>-->

                    <div class="autopilot-wrap">
                        <!--<form id="autopilot-demo" method="post" action="/secure/registerquick.php" class="form-inline">-->
                            <!--<div class="form-group input-group-lg">-->
                                <!--<input type="text" placeholder="Name" required="" name="name" id="name" class="form-control required"></div>-->
                            <!--<div class="form-group input-group-lg">-->
                                <!--<input type="email" placeholder="Email" required="" name="email" id="email" class="form-control required"></div>-->
                            <!--<div class="form-group input-group-lg">-->
                                <!--&lt;!&ndash; <button class="btn btn-secondary" type="submit">Hook me up</button>&ndash;&gt;-->
                                <!--&lt;!&ndash; <button class="btn btn-secondary" type="submit">Create Account</button>&ndash;&gt;-->
                                <!--<button class="btn btn-secondary" type="submit">Create Account</button>-->

                            <!--</div>-->
                        <!--</form>-->

<!--                        <a href="https://share.hsforms.com/18QLgOq0vQx675TanD46a8g4q4l7" class="btn btn-secondary" type="submit" v-on:click="clickEvent('beta')">Try The Beta</a>-->
                      <a href="/refunds" class="btn btn-primary mr-10">See Our Refund Policy</a>
<!--                      <a href="/deploy-wizard" class="btn btn-secondary" v-on:click="clickEvent('try_now')">Try Now</a>-->
                    </div>
                </div>

            </div>
        </section>

</template>

<script>
    export default {
      name: 'FooterSignup',
      props: {
          msg: String
      },
      methods: {
        clickEvent(name) {
          this.$gtag.event('nav', 'click', name)
        },
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
